import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { ConstantsService } from './constants.service';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  getDailyCubeoutKPIReport(addObject) {
    return this.http.post(`${this.constantsService.baseAPIURL}/eboi/getDailyCubeoutKPIReport`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
    .pipe(
      catchError(this.handleError));
  }
  runReasonDropDown(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/dailyCubeOut/reasonCodes`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }
  runPeriodDropDown(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/dailyCubeOut/getPeriods`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }
  runDomicileDropDown(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/dailyCubeOut/domiciles`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }

  constructor(private readonly http: HttpClient, private readonly constantsService: ConstantsService) { }
  // Eboi KPI 
  loadDataEboiDailyExpedite(): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/home/dailyExpedite`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  getRouteByDomicile(domicile): Observable<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/home/drpDown/routes/${domicile}`, this.constantsService.httpCustomOptions)
      .pipe(
        catchError(this.handleError));
  }

  costCenterDrpDwn(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/home/drpDown/costCenters`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }

  domicileDrpDwn(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/home/drpDwn/domiciles`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }

  reasonIdDrpDwn(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/home/drpDwn/reasonId`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }

  carrierDrpDwm(): Promise<any> {
    return this.http
      .get(`${this.constantsService.baseAPIURL}/eboi/home/drpDwn/carrier`, this.constantsService.httpCustomOptions)
      .pipe(map(res => res))
      .toPromise();
  }

  addEboiHome(addObject) {

    return this.http.post(`${this.constantsService.baseAPIURL}/eboi/home/addDailyExpedite`, addObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
      .pipe(
        catchError(this.handleError));
  }

  updateEboiHome(updateObject, previosCostCentre) {

    return this.http.put(`${this.constantsService.baseAPIURL}/eboi/Home/update/${previosCostCentre}`, updateObject, { headers: this.constantsService.httpOptions, responseType: 'text' })
      .pipe(
        catchError(this.handleError));
  }

  deleteRecord(loadnumber): Observable<any> {
    return this.http
      .delete(`${this.constantsService.baseAPIURL}/eboi/Home/delete/${loadnumber}`, { headers: this.constantsService.httpOptions, responseType: 'text' })
      .pipe(
        catchError(this.handleError));
  }

  // UPLOAD
  uploadExcelFileData(excelFile: File, userId): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', excelFile, excelFile.name)
    return this.http.post(`${this.constantsService.baseAPIURL}/eboi/home/importEboi/${userId}`, formData, { responseType: 'text' })
      .pipe(
        timeout(260000),
        catchError(this.handleError));
  }

  downloadTemplate() {
    const reportObject = {}
    return this.http.post(`${this.constantsService.baseAPIURL}/eboi/getTemplate`, reportObject, { headers: this.constantsService.httpOptions, responseType: 'blob' })
      .pipe(
        timeout(260000),
        catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
}
